import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';

// Shown instead of a blank page when a section is for a different kind of account.
export default function RoleGate({ who, user, onOpenAuth, onNavigate }) {
  return (
    <div className="max-w-md mx-auto my-12 rounded-xl border bg-card p-6 text-center space-y-3" data-testid="role-gate">
      <div className="mx-auto h-10 w-10 rounded-full bg-muted flex items-center justify-center"><Lock className="h-5 w-5 text-muted-foreground" /></div>
      <h2 className="text-lg font-semibold" data-testid="role-gate-title">{who ? `This page is for ${who}` : 'Sign in to open this page'}</h2>
      <p className="text-sm text-muted-foreground">
        {user ? 'Your account does not have access to this page.' : 'Please sign in with the right account to open it.'}
      </p>
      <div className="flex justify-center gap-2">
        {!user && <Button size="sm" onClick={() => onOpenAuth?.('login')} data-testid="role-gate-signin">Sign in</Button>}
        <Button size="sm" variant="outline" onClick={() => onNavigate('home')} data-testid="role-gate-home">Go to Home</Button>
      </div>
    </div>
  );
}
